import {
  ColorPickerUpdateFormField,
  InputUpdateFormField,
} from '@/domain/termine/features/UpdateTerminkalender/shared/FormFields';
import { useTranslation } from 'react-i18next';

export function UpdateTerminKalenderFormContent() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4 px-6">
      <span className="font-normal text-neutrals-700 text-xs md:py-2 xs:py-6">
        {t('domain.termine.sheet.pflichtfelder')}
      </span>
      <div className="flex flex-col flex-1 gap-4">
        <div className="flex flex-col gap-4 flex-1">
          <div className="flex gap-4 items-start">
            <InputUpdateFormField />
            <ColorPickerUpdateFormField />
          </div>
        </div>
      </div>
    </div>
  );
}
